/**
 * Stats Card Component
 * 
 * This component displays individual statistics cards
 * with icons, titles, and values.
 */

import React from 'react';

const StatsCard = ({ icon, title, value }) => {
  return (
    <div className="stat-card">
      <div className="stat-icon">{icon}</div>
      <div className="stat-content">
        <h3 className="stat-title">{title}</h3>
        <p className="stat-value">{value}</p>
      </div>
    </div>
  );
};

export default StatsCard;
